// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"checkboxlist_checkboxes__1pjhN","checkboxesInside":"checkboxlist_checkboxesInside__t_7Os","checkboxesInsideSubText":"checkboxlist_checkboxesInsideSubText__LK8gG"};